import { Lightformer, ContactShadows, useGLTF, useAnimations, Environment, OrbitControls } from '@react-three/drei'
import { EffectComposer, Bloom, ToneMapping } from '@react-three/postprocessing'
import { Perf } from 'r3f-perf'
import DCW from './DCW.jsx'


export default function Experience()
{
    const dude = useGLTF('./dcw_character/glb/dcw.glb')
    const animations = useAnimations(dude.animations, dude.scene)    

    return <>

        {/* <Perf position="top-left" /> */}
        <Environment preset='warehouse' />
        <directionalLight castShadow position={ [ 1, 2, 3 ] } intensity={ 10.5 } shadow-normalBias={ 0.04 } color={"#9999bb"} />
        <ambientLight intensity={ 5.5 } color={"#bbbbff"} />
       

        <Lightformer 
            form={"ring"}
            intensity={1}
            scale={1.7}
            target={[0,-2,0.5]}
            position={[ 0, -0.999, 0.5]}
        />
                
        <OrbitControls autoRotate autoRotateSpeed={0.05} enableZoom={false} makeDefault minPolarAngle={Math.PI / 4} maxPolarAngle={Math.PI / 4} />

        {/* <mesh receiveShadow position-y={ - 1 } rotation-x={ - Math.PI * 0.5 } scale={ 10 }>
            <planeGeometry />
            <meshStandardMaterial color="greenyellow" />
        </mesh> */}
        <DCW />
        <ContactShadows 
            position={ [ 0, -1, 0 ] }
            opacity={ 0.1}
            scale={ 5 }
            blur={ 1.2 }
        />
      
    </>
}